import type { SearchableFilterOption } from "@/components/ui/SearchableFilter";

/**
 * Lọc danh sách lựa chọn của combobox theo chuỗi người dùng gõ.
 *
 * Tách ra khỏi component để kiểm được bằng test: chỗ này quyết định người dùng
 * CÓ THẤY dòng mình vừa tìm hay không, và sai ở đây thì màn hình báo "không có
 * kết quả" cho một khách hàng đang tồn tại.
 */
export function filterOptions(
  options: readonly SearchableFilterOption[],
  query: string,
  opts: { includeAll: boolean; allLabel: string; remote?: boolean },
): SearchableFilterOption[] {
  const needle = query.trim().toLowerCase();
  // Tách từ rồi bắt buộc có ĐỦ: gõ "Long An" mà so cả cụm thì trượt ngay khi
  // dữ liệu ghi "Long  An" hay "Long An province," — người dùng gõ nhiều từ là
  // đang thu hẹp, không phải đọc chính tả một chuỗi.
  const terms = needle.split(/\s+/).filter(Boolean);
  /**
   * Máy chủ đã lọc rồi thì KHÔNG lọc lại.
   *
   * Máy chủ có thể khớp trên cột không hiện ra (mã khách, mã số thuế, tên viết
   * tắt). Lọc thêm tại máy theo đúng chữ đang gõ sẽ giấu mất chính dòng mà máy
   * chủ vừa tìm được, và người dùng thấy "không có kết quả" cho thứ có thật.
   */
  const rows =
    terms.length && !opts.remote
      ? options.filter((o) => {
          // Tìm cả trên dòng phụ: dòng phụ hiện ra để phân biệt hai công ty
          // trùng tên, nên gõ nó cũng phải tìm được, không chỉ để trang trí.
          const hay = `${o.label} ${o.sublabel ?? ""}`.toLowerCase();
          return terms.every((term) => hay.includes(term));
        })
      : options;
  const showAll = opts.includeAll && (!needle || opts.allLabel.toLowerCase().includes(needle));
  return showAll ? [{ value: "", label: opts.allLabel }, ...rows] : [...rows];
}
